import './analytics.css';

import { useEffect, useState, useMemo } from 'react';

import Totals from '../../../components/analyticsComponents/totals/totals';
import RevBudInput from '../../../components/analyticsComponents/rev&BudInput/rev&BudInput';
import RevenueBreakdown from '../../../components/analyticsComponents/revenueBreakdown/revenueBreakdown';
import TimeLineBig from '../../../components/analyticsComponents/timeLineBig/timeLineBig';
import PieCat from '../../../components/analyticsComponents/pieCat/pieCat';
import LineChartComponent from '../../../components/analyticsComponents/lineChart/lineChart';
import BarChartComponent from '../../../components/analyticsComponents/barChart/barChart';
import BudgetBreakdown from '../../../components/analyticsComponents/budgetBreakdown/budgetBreakdown';


export default function Analytics({expenses, filteredExpenses, filteredCategories}){

    const [organizationData, setOrganizationData] = useState([{revenue: 1209, budget: 700}, {revenue: 4836, budget: 2800}, {revenue: 29016, budget: 16800}, {revenue: 18032, budget: 33600}]);

    const [analyticsTime, setAnalyticsTime] = useState(0);

    const handleTimeChange = (time) => {
        setAnalyticsTime(time);
    };

    const handleRevChange = (e, index) => {
    const value = Number(e.target.value) || 0;
    setOrganizationData(prevData =>
      prevData.map((item, i) =>
        i === index ? { ...item, revenue: value } : item
      )
    );
  };

    const handleBudgChange = (e, index) => {
    const value = Number(e.target.value) || 0;
    setOrganizationData(prevData =>
      prevData.map((item, i) =>
        i === index ? { ...item, budget: value } : item
      )
    );
  };

    return (
        <div className="analytics">

            <div className="analytics-container">

                <div className="analytics-container-top">

                    <div className="analytics-container-top-left">

                        <Totals analyticsTime={analyticsTime} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories} />
                        <RevBudInput organizationData={organizationData} analyticsTime={analyticsTime} handleRevChange={handleRevChange} handleBudgChange={handleBudgChange}/>
                        <RevenueBreakdown analyticsTime={analyticsTime}  organizationData={organizationData} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories}/>

                    </div>

                    <div className="analytics-container-top-right">
                        <TimeLineBig onTimeChange={handleTimeChange}/>
                        <PieCat filteredCategories={filteredCategories} analyticsTime={analyticsTime}/>
                    </div>
            
                </div>

                <div className="analytics-container-bottom">
                    <LineChartComponent analyticsTime={analyticsTime} organizationData={organizationData} filteredCategories={filteredCategories}/>
                    <BarChartComponent analyticsTime={analyticsTime} organizationData={organizationData} filteredCategories={filteredCategories}/>
                    <BudgetBreakdown analyticsTime={analyticsTime}  organizationData={organizationData} filteredCategories={filteredCategories}/>
                </div>

            </div>
        </div>
    )
}